import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle, XCircle } from 'lucide-react';
export function WhoIsThisFor() {
  const isFor = ['Hombres y mujeres de 50+ años que sufren de reflujo al menos 3 veces por semana.', "Personas que han notado que su digestión se volvió 'lenta' o pesada.", 'Amantes de la comida latina que no quieren vivir a base de ensaladas insípidas.', 'Quienes dependen de fármacos diarios para poder dormir sin ardor.'];
  const isNotFor = ['Personas que buscan una cura mágica para úlceras sangrantes o condiciones quirúrgicas graves.', 'Quienes no están dispuestos a cambiar pequeños hábitos (como el orden en que beben agua).', 'Personas que prefieren seguir tomando pastillas de por vida antes que ajustar su sazón.'];
  return <SectionWrapper bgColor="white" data-id="element-144">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-145">
        {/* Para ti si */}
        <div className="bg-brand-sage/30 p-8 rounded-3xl border border-brand-sage" data-id="element-146">
          <h3 className="font-serif text-2xl font-bold text-brand-forest mb-6" data-id="element-147">
            Esto es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-148">
            {isFor.map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-149">
                <CheckCircle className="w-6 h-6 text-brand-cta flex-shrink-0 mt-1" data-id="element-150" />
                <span className="text-gray-800 text-lg" data-id="element-151">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* No es para ti si */}
        <div className="bg-red-50/50 p-8 rounded-3xl border border-red-100" data-id="element-152">
          <h3 className="font-serif text-2xl font-bold text-gray-800 mb-6" data-id="element-153">
            NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-154">
            {isNotFor.map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-155">
                <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-156" />
                <span className="text-gray-700 text-lg" data-id="element-157">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </SectionWrapper>;
}